import { createApp } from 'vue';
import axios from 'axios';
import { Chart } from 'chart.js/auto';

const app = createApp({
  data() {
    return {
      cellname: null,
      monsoles: [],
      totalResult: 0,
      panelNum: 0,
      panelPower: 0,
      oilLiter: 0,
      oilVolume: 0,
      co2: 0,
      sugi: 0,
      answer1: true,
      answer2: true,
      answer3: true,
      answer4: true,
      answer5: true,
      selectWrap: false,
      resultWrap: true,
      areas: [
        { "id": 1, "name": "北海道", "is_checked": false },
        { "id": 2, "name": "東北", "is_checked": false },
        { "id": 3, "name": "関東", "is_checked": false },
        { "id": 4, "name": "中部", "is_checked": false },
        { "id": 5, "name": "近畿", "is_checked": false },
        { "id": 6, "name": "中国", "is_checked": false },
        { "id": 7, "name": "四国", "is_checked": false },
        { "id": 8, "name": "九州", "is_checked": false },
        { "id": 9, "name": "沖縄", "is_checked": false },
      ],
      prefectures: [
        { "area": 1, "name": "北海道", "city": "北海道", "is_checked": false, "is_display": false },
        { "area": 2, "name": "青森", "city": "青森", "is_checked": false, "is_display": false },
        { "area": 2, "name": "岩手", "city": "岩手", "is_checked": false, "is_display": false },
        { "area": 2, "name": "宮城", "city": "宮城", "is_checked": false, "is_display": false },
        { "area": 2, "name": "秋田", "city": "秋田", "is_checked": false, "is_display": false },
        { "area": 2, "name": "山形", "city": "山形", "is_checked": false, "is_display": false },
        { "area": 2, "name": "福島", "city": "福島", "is_checked": false, "is_display": false },
        { "area": 3, "name": "茨城", "city": "茨城", "is_checked": false, "is_display": false },
        { "area": 3, "name": "栃木", "city": "栃木", "is_checked": false, "is_display": false },
        { "area": 3, "name": "群馬", "city": "群馬", "is_checked": false, "is_display": false },
        { "area": 3, "name": "埼玉", "city": "埼玉", "is_checked": false, "is_display": false },
        { "area": 3, "name": "千葉", "city": "千葉", "is_checked": false, "is_display": false },
        { "area": 3, "name": "東京", "city": "東京", "is_checked": false, "is_display": false },
        { "area": 3, "name": "神奈川", "city": "神奈川", "is_checked": false, "is_display": false },
        { "area": 4, "name": "新潟", "city": "新潟", "is_checked": false, "is_display": false },
        { "area": 4, "name": "富山", "city": "富山", "is_checked": false, "is_display": false },
        { "area": 4, "name": "石川", "city": "石川", "is_checked": false, "is_display": false },
        { "area": 4, "name": "福井", "city": "福井", "is_checked": false, "is_display": false },
        { "area": 4, "name": "山梨", "city": "山梨", "is_checked": false, "is_display": false },
        { "area": 4, "name": "長野", "city": "長野", "is_checked": false, "is_display": false },
        { "area": 4, "name": "岐阜", "city": "岐阜", "is_checked": false, "is_display": false },
        { "area": 4, "name": "静岡", "city": "静岡", "is_checked": false, "is_display": false },
        { "area": 4, "name": "愛知", "city": "愛知", "is_checked": false, "is_display": false },
        { "area": 5, "name": "三重", "city": "三重", "is_checked": false, "is_display": false },
        { "area": 5, "name": "滋賀", "city": "滋賀", "is_checked": false, "is_display": false },
        { "area": 5, "name": "京都", "city": "京都", "is_checked": false, "is_display": false },
        { "area": 5, "name": "大阪", "city": "大阪", "is_checked": false, "is_display": false },
        { "area": 5, "name": "兵庫", "city": "兵庫", "is_checked": false, "is_display": false },
        { "area": 5, "name": "奈良", "city": "奈良", "is_checked": false, "is_display": false },
        { "area": 5, "name": "和歌山", "city": "和歌山", "is_checked": false, "is_display": false },
        { "area": 6, "name": "鳥取", "city": "鳥取", "is_checked": false, "is_display": false },
        { "area": 6, "name": "島根", "city": "島根", "is_checked": false, "is_display": false },
        { "area": 6, "name": "岡山", "city": "岡山", "is_checked": false, "is_display": false },
        { "area": 6, "name": "広島", "city": "広島", "is_checked": false, "is_display": false },
        { "area": 6, "name": "山口", "city": "山口", "is_checked": false, "is_display": false },
        { "area": 7, "name": "徳島", "city": "徳島", "is_checked": false, "is_display": false },
        { "area": 7, "name": "香川", "city": "香川", "is_checked": false, "is_display": false },
        { "area": 7, "name": "愛媛", "city": "愛媛", "is_checked": false, "is_display": false },
        { "area": 7, "name": "高知", "city": "高知", "is_checked": false, "is_display": false },
        { "area": 8, "name": "福岡", "city": "福岡", "is_checked": false, "is_display": false },
        { "area": 8, "name": "佐賀", "city": "佐賀", "is_checked": false, "is_display": false },
        { "area": 8, "name": "長崎", "city": "長崎", "is_checked": false, "is_display": false },
        { "area": 8, "name": "熊本", "city": "熊本", "is_checked": false, "is_display": false },
        { "area": 8, "name": "大分", "city": "大分", "is_checked": false, "is_display": false },
        { "area": 8, "name": "宮崎", "city": "宮崎", "is_checked": false, "is_display": false },
        { "area": 8, "name": "鹿児島", "city": "鹿児島", "is_checked": false, "is_display": false },
        { "area": 9, "name": "沖縄", "city": "沖縄", "is_checked": false, "is_display": false }
      ],
      prefectureSelected: [],
      angles: [
        { "id": 1, "name": "緩やかな屋根（1寸 およそ６°）", "angle": 6, "img": "/wp-content/themes/canadian_solar/img/img/img_house01.png", "is_checked": false },
        { "id": 2, "name": "標準的な屋根（4寸 およそ20°）", "angle": 20, "img": "/wp-content/themes/canadian_solar/img/img/img_house02.png", "is_checked": false },
        { "id": 3, "name": "急な屋根（8寸 およそ40°）", "angle": 40, "img": "/wp-content/themes/canadian_solar/img/img/img_house03.png", "is_checked": false },
      ],
      directions: [
        { "id": 1, "name": "西", "direction": 90, "is_checked": false },
        { "id": 2, "name": "南西", "direction": 45, "is_checked": false },
        { "id": 3, "name": "南", "direction": 0, "is_checked": false },
        { "id": 4, "name": "南東", "direction": 45, "is_checked": false },
        { "id": 5, "name": "東", "direction": 90, "is_checked": false },
      ],
      panels: [
        { "id": 1, "name": "建坪", "unit": "坪", "err": "坪数を入力してください", "is_checked": false, "is_error": false },
        { "id": 2, "name": "枚数", "unit": "枚", "err": "枚数を入力してください", "is_checked": false, "is_error": false },
      ],
      panelNums: [
        { panelNum0: null },
        { panelNum1: null },
      ],
      monthDays: [
        { "month": 1, "day": 31 },
        { "month": 2, "day": 28 },
        { "month": 3, "day": 31 },
        { "month": 4, "day": 30 },
        { "month": 5, "day": 31 },
        { "month": 6, "day": 30 },
        { "month": 7, "day": 31 },
        { "month": 8, "day": 31 },
        { "month": 9, "day": 30 },
        { "month": 10, "day": 31 },
        { "month": 11, "day": 30 },
        { "month": 12, "day": 31 },
      ],
    };
  },
  beforeCreate() {
    var self = this;
    axios.get("/wp-content/themes/canadian_solar/monsola20/result_files/monsola20.json")
      .then(function (response) {
        self.monsoles = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods: {
    selectArea(area) {
      this.answer1 = false;
      this.areaSelected = area;
      this.areas.forEach(function (item) {
        item.is_checked = false;
      });
      area.is_checked = true;
      this.prefectures.forEach(function (item) {
        if (item.area == area.id) {
          item.is_display = true;
        } else {
          item.is_display = false;
        }
      });
    },
    selectPrefecture(prefecture) {
      this.answer2 = false;
      this.prefectureSelected = prefecture;
      this.prefectures.forEach(function (item) {
        item.is_checked = false;
      });
      prefecture.is_checked = true;
    },
    selectAngle(angle) {
      this.answer3 = false;
      this.angleSelected = angle;
      this.angles.forEach(function (item) {
        item.is_checked = false;
      });
      angle.is_checked = true;
    },
    selectDirection(direction) {
      this.answer4 = false;
      this.directionSelected = direction;
      this.directions.forEach(function (item) {
        item.is_checked = false;
      });
      direction.is_checked = true;
    },
    selectPanel(panel) {
      this.answer5 = false;
      this.panelSelected = panel;
      this.panels.forEach(function (item) {
        item.is_checked = false;
      });
      panel.is_checked = true;
    },
    resultDisplay() {
      // 選択都市取得
      var city = this.prefectureSelected.city;
      var selectedMonsola = [];
      var monthlyMonsola = [];
      var monthlyResult = [];
      var totalResult = null;
      var panelPower = 0;
      var panelPower_adjust = 0;
      // 太陽電池容量
      var cell_power = document.getElementById("cell_power").value;
      // 太陽電池出力の公差
      var cell_adjust = document.getElementById("cell_adjust").value;
      // パワコン係数
      var powercon_value = document.getElementById("powercon_value").value;
      // その他損失
      var other_value = document.getElementById("other_value").value;

      var angle = this.angleSelected.angle;

      if (this.panelSelected.id == 1) {
        if (!this.panelNums.panelNum0) {
          this.panelSelected.is_error = true;
          return false;
        } else {
          this.panelSelected.is_error = false;
        }
        var heibei = this.panelNums.panelNum0 / 0.3025;
        var yane_menseki = heibei / Math.cos(angle * (Math.PI / 180));
        var katanagare_yane = yane_menseki ^ (0.5);
        var secchikanou_menseki = (katanagare_yane - 0.2) ^ 2;
        this.panelNum = Math.floor(secchikanou_menseki / 1.95); // 1.85 -> 1.95
        // console.log(this.panelNums.panelNum0, heibei, yane_menseki, katanagare_yane, secchikanou_menseki);
      } else {
        if (!this.panelNums.panelNum1) {
          this.panelSelected.is_error = true;
          return false;
        } else {
          this.panelSelected.is_error = false;
        }
        this.panelNum = this.panelNums.panelNum1;
      }

      // 結果表示画面に切替
      this.resultWrap = false;
      this.selectWrap = true;

      // 結果の先頭に移動
      var position = $('#app').offset().top
      $("html, body").animate({ scrollTop: position }, 800, "swing");

      // 太陽電池モジュール出力表示
      panelPower = (parseInt(cell_power) * this.panelNum) / 1000;
      this.panelPower = panelPower;

      // 太陽電池モジュール出力 (公差込み)
      panelPower_adjust = ((parseInt(cell_power) + parseInt(cell_adjust)) * this.panelNum) / 1000;
      // console.log(cell_power, cell_adjust, this.panelNum, panelPower);

      // monsola データ取得
      this.monsoles.forEach(function (item) {
        if (item[0] == city) {
          selectedMonsola = item[1];
          // console.log(selectedMonsola);
        }
      });

      // monsola
      var direction = this.directionSelected.direction;
      if (angle == 6) {
        // console.log('6degMode', direction);
      }
      if (angle == 6) {
        var item0 = [];
        var item1 = [];
        selectedMonsola.forEach(function (item) {
          if (item[0] == 0 && item[1] == 0) {
            item0 = item;
            // console.log(0, item);
          }
          if (item[0] == direction && item[1] == 10) {
            item1 = item;
            // console.log(1, item);
          }
        });
        monthlyMonsola[0] = item0[0];
        monthlyMonsola[1] = angle;
        for (var i = 2; i < 14; i++) {
          // console.log(item1[i], item0[i], item1[1], item0[1], angle, parseFloat(item0[i]));
          monthlyMonsola[i] = (item1[i] - item0[i]) / (item1[1] - item0[1]) * (angle - item0[1]) + parseFloat(item0[i]);
        }
        // console.log(monthlyMonsola);
      } else {
        selectedMonsola.forEach(function (item) {
          if (item[0] == direction && item[1] == angle) {
            // console.log(item);
            monthlyMonsola = item;
          }
        });
      }
      this.monthDays.forEach(function (item, index) {
        var id = "month" + ('00' + (index + 1)).slice(-2);
        // 温度補正係数
        var temp = document.getElementById(id).value;

        // 各月の日射量 * 日数 * 温度補正係数 * 太陽電池容量 * パワコン係数 * その他損失
        monthlyResult[index] = Math.trunc(monthlyMonsola[index + 2] * item.day * temp * panelPower_adjust * powercon_value * other_value);
        console.log(index, monthlyMonsola[index + 2], item.day, temp, panelPower, cell_adjust,panelPower_adjust, powercon_value, other_value, monthlyResult[index]);
        totalResult = totalResult + monthlyResult[index];
      });

      // CO2換算
      var co2 = totalResult * 0.3925; // 0.3995 -> 0.3875 -> 0.3925
      this.co2 = new Intl.NumberFormat('ja-JP').format(Math.round(co2));

      // 原油換算
      var oilLiter = totalResult * 0.222; // 0.227 -> 0.222
      this.oilLiter = new Intl.NumberFormat('ja-JP').format(Math.round(oilLiter));
      this.oilVolume = Math.round(oilLiter / 18);

      // スギ換算
      this.sugi = Math.round(co2 / 14);

      this.totalResult = new Intl.NumberFormat('ja-JP').format(Math.trunc(totalResult));

      var chartEl1 = document.getElementById('myChart')
      var ctx = chartEl1.getContext('2d');
      const chart_cv = new Chart(ctx, {
        type: 'bar', // グラフの種類
        data: {
          labels: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          datasets: [
            {
              data: monthlyResult,
              backgroundColor: "#1A68BE"
            },
          ],
        }, // データ
        options: {
          maintainAspectRatio: false,
          plugins: {
            tooltips: {
              mode: 'point',
              intersect: false,
            },
            title: {
              display: true,
              text: '推定発電量 (kWh)',
              font: {
                size: 14,
                weight: 'bold',
              },
              padding: {
                top: 10,
                bottom: 10,
              },
            },
            legend: {
              display: false,
            },
            scales: {                          // 軸設定
              y: {
                beginAtZero: true,    // 最小値を0に設定
                ticks: {                       // 目盛り
                  min: 0,                        // 最小値
                }
              }
            }
          }
        }
      });
    },
    rerutnSelect() {
      this.selectWrap = false;
      this.resultWrap = true;
    }
  }
});

// DOMContentLoadedイベントで初期化
document.addEventListener('DOMContentLoaded', () => {
  app.mount('#app');
});
